/*
 * Copyright (c) 2024. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { typedInvert } from '../utils';
export var SiteRecordType;
(function (SiteRecordType) {
    SiteRecordType["PURCHASE_OPTION"] = "Purchase Option";
    SiteRecordType["EASEMENT_OPTION"] = "Easement Option";
    SiteRecordType["LEASE_OPTION"] = "Lease Option";
    SiteRecordType["MINERAL_PURCHASE_OPTION"] = "Mineral Purchase Option";
    SiteRecordType["MINERALS_OWNED_IN_FEE"] = "Minerals Owned in Fee";
    SiteRecordType["OWNED_IN_FEE"] = "Owned in Fee";
    SiteRecordType["WATER_LEASE_OPTION"] = "Water Lease Option";
})(SiteRecordType || (SiteRecordType = {}));
export const siteRecordIdTypeMap = {
    '0125w000001R422AAC': SiteRecordType.PURCHASE_OPTION,
    '0125w000001R427AAC': SiteRecordType.EASEMENT_OPTION,
    '012EX0000004HzxYAE': SiteRecordType.LEASE_OPTION,
    '012EX0000004Ky8YAE': SiteRecordType.MINERAL_PURCHASE_OPTION,
    '012EX0000004Ky3YAE': SiteRecordType.MINERALS_OWNED_IN_FEE,
    '012EX0000004IQqYAM': SiteRecordType.OWNED_IN_FEE,
    '012EX0000004L1gYAE': SiteRecordType.WATER_LEASE_OPTION,
};
export const siteRecordTypeIdMap = typedInvert(siteRecordIdTypeMap);
//# sourceMappingURL=sites.js.map